<template>
  <TableComp
    :headers="headers"
    :name="$t('global.other')"
    :status="others.status"
    :pagination="others.pagination"
    :sort="others.sort"
    :number-of-items="others.list.length"
    v-on:update:list="updateList"
  >
    <template #desktop>
      <TableRow v-for="item in others.list" :key="item.id">
        <td class="align-middle">
          <router-link :to="{ name: 'other-detail', params: { id: item.id } }">
            {{ item.description }}
          </router-link>
        </td>
        <td class="align-middle text-center">
          <Pill
            :content="$t(`global.${item.autoRenew}`)"
            :variant="getStatusVariant(item.autoRenew)"
          />
        </td>
        <td class="align-middle text-center">
          {{ item.billing.formattedNextBillDate }}
          <Popover
            v-if="item.paypal.hasSubscription"
            :header="$t(`global.paypal-subscription`)"
            :title="item.paypal.id"
            :message="
              $t('global.active-paypal-tooltip', {
                startDate: item.paypal.formattedStartDate,
              })
            "
          >
            <Logo logo="paypal" />
          </Popover>
        </td>
        <td class="align-middle text-center">
          {{ item.billing.price }}
        </td>
        <td class="align-middle text-center">
          <Pill :content="$t(`global.${item.status}`)" :variant="getStatusVariant(item.status)" />
        </td>
        <td class="text-end actions">
          <div class="d-flex justify-content-end mr-4">
            <ThreeDotsMenu :items="menuItems(item)" />
          </div>
        </td>
      </TableRow>
    </template>
    <template #mobile>
      <TableMobileRow
        v-for="item in others.list"
        v-bind:key="item.id"
        :menu-items="menuItems(item)"
      >
        <template #header:title>
          <router-link :to="{ name: 'other-detail', params: { id: item.id } }">
            {{ item.description }}
          </router-link>
        </template>

        <template #content>
          <div class="row">
            <div class="col">{{ $t("global.auto-renew") }}:</div>
            <div class="col">
              <Pill
                :content="$t(`global.${item.autoRenew}`)"
                :variant="getStatusVariant(item.autoRenew)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.next-bill") }}:</div>
            <div class="col">
              {{ item.billing.formattedNextBillDate }}
              <Popover
                v-if="item.paypal.hasSubscription"
                :header="$t(`global.paypal-subscription`)"
                :title="item.paypal.id"
                :message="
                  $t('global.active-paypal-tooltip', {
                    startDate: item.paypal.formattedStartDate,
                  })
                "
              >
                <Logo logo="paypal" />
              </Popover>
            </div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.price") }}:</div>
            <div class="col">
              {{ item.billing.price }}
            </div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.status") }}:</div>
            <div class="col">
              <Pill
                :content="$t(`global.${item.status}`)"
                :variant="getStatusVariant(item.status)"
              />
            </div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { getContactSupport, getDeleteService } from "@/utils/serviceMenuOptions";
import { getStatusVariant } from "@/utils/statusVariant";
import Logo from "@/components/display/Logo";
import NavLink from "@/classes/NavLink";
import Pill from "@/components/display/Pill";
import Popover from "@/components/display/Popover";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "OthersTable",
  props: {
    others: {
      type: Object,
      required: true,
    },
  },
  components: {
    Logo,
    Pill,
    Popover,
    TableComp,
    TableMobileRow,
    TableRow,
    ThreeDotsMenu,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.details")),
      new TableHeader(root.$t("global.auto-renew"), "justify-content-center"),
      new TableHeader(root.$t("global.next-bill"), "justify-content-center"),
      new TableHeader(root.$t("global.price"), "justify-content-center"),
      new TableHeader(root.$t("global.status"), "justify-content-center"),
      new TableHeader(),
    ];

    const menuItems = (item) => {
      const items = [
        new NavLink(
          root.$t("global.view"),
          null,
          { name: "other-detail", params: { id: item.id } },
          false,
          "default"
        ),
      ];

      items.push(getContactSupport(item), getDeleteService(item));

      return items.filter((i) => i !== null);
    };

    const updateList = (event) => {
      const { pagination, sort } = event;
      store.dispatch("others/getList", {
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
        sortProperty: sort?.property,
        sortDirection: sort?.direction,
      });
    };

    return {
      getStatusVariant,
      headers,
      menuItems,
      updateList,
    };
  },
};
</script>
